import * as React from "react";
import { cn } from "../../../lib/utils";
import { Card, CardFooter } from "../card";

function FormSection({ title, className, children, footer }) {
  return (
    <Card variant="form" padding="lg" className={cn("mb-8", className)}>
      {title && (
        <h3 className="mb-6 text-lg font-semibold text-[#374151]">{title}</h3>
      )}
      {children}
      {footer && <CardFooter className="mt-6 border-0 pt-0">{footer}</CardFooter>}
    </Card>
  );
}

function FormGrid({ className, columns = "auto", children }) {
  const gridClass =
    columns === "three"
      ? "grid grid-cols-3 gap-4 mb-4 max-md:grid-cols-1"
      : columns === "two"
        ? "grid grid-cols-2 gap-4 mb-4 max-md:grid-cols-1"
        : "grid grid-cols-[repeat(auto-fit,minmax(250px,1fr))] gap-6 max-md:grid-cols-1 max-md:gap-4";

  return <div className={cn(gridClass, className)}>{children}</div>;
}

function FormActions({ className, children }) {
  return (
    <div
      className={cn(
        "flex gap-3 justify-end mt-6 max-md:flex-col max-md:items-stretch [&_button]:max-md:w-full",
        className,
      )}
    >
      {children}
    </div>
  );
}

export { FormSection, FormGrid, FormActions };
